import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const PWA_DECLINE_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

interface PWAInstallState {
  installPromptEvent: BeforeInstallPromptEvent | null;
  isInstallable: boolean;
  isInstalled: boolean;
  declinedAt: number | null;
  dialogOpen: boolean;
  setInstallPromptEvent: (event: BeforeInstallPromptEvent | null) => void;
  setIsInstalled: (installed: boolean) => void;
  markDeclined: () => void;
  shouldShowPrompt: () => boolean;
  setDialogOpen: (open: boolean) => void;
}

export const usePWAInstallStore = create<PWAInstallState>()(
  persist(
    (set, get) => ({
      installPromptEvent: null,
      isInstallable: false,
      isInstalled: false,
      declinedAt: null,
      dialogOpen: false,
      setInstallPromptEvent: (event) => {
        set({
          installPromptEvent: event,
          isInstallable: event !== null
        });
      },
      setIsInstalled: (installed) => {
        set({ isInstalled: installed });
      },
      markDeclined: () => {
        set({
          declinedAt: Date.now(),
          installPromptEvent: null,
          isInstallable: false
        });
      },
      shouldShowPrompt: () => {
        const { isInstallable, isInstalled, declinedAt } = get();

        if (isInstalled) return false;
        if (!isInstallable) return false;

        if (declinedAt !== null) {
          const timeSinceDeclined = Date.now() - declinedAt;
          if (timeSinceDeclined < PWA_DECLINE_COOLDOWN_MS) return false;
        }

        return true;
      },
      setDialogOpen: (open) => {
        set({ dialogOpen: open });
      }
    }),
    {
      name: 'ludoka-pwa-install',
      partialize: (state) => ({
        declinedAt: state.declinedAt,
        isInstalled: state.isInstalled
      })
    }
  )
);
